import { Grid } from 'antd';

export interface IAppBreakpoint {
  /** Below 768px (antd's `md`). */
  isMobile: boolean;
  /** 768px–991px, i.e. `md` but not yet `lg`. */
  isTablet: boolean;
  /** 992px (antd's `lg`) and above. */
  isDesktop: boolean;
}

/**
 * Single source of truth for the app's two breakpoints (768/992), wrapping
 * antd's own `Grid.useBreakpoint()` instead of every consumer re-deriving
 * isMobile/isDesktop from `screens.md`/`screens.lg` its own way.
 */
export const useAppBreakpoint = (): IAppBreakpoint => {
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const isDesktop = !!screens.lg;
  const isTablet = !isMobile && !isDesktop;
  return { isMobile, isTablet, isDesktop };
};
